<div class="manager-loader-wrapper-modal" [class]="appS.navigationS.navigations[this.type + '.' + this.wrapper]?.step" [ngClass]="{ header: header, footer: footer }">
  <div class="spinner-border w-55px h-55px"></div>
</div>
